
<template>
  <div id="app">
      <index/>
  </div>
</template>

<script>
import index from './components/index.vue'

export default {
  name: 'App',
  components: {
    index
  }
}
</script>

<style>
html,body{
    padding: 0;
    margin: 0;
    background: #252525;
}
#app {
  font-family: "Helvetica Neue",Helvetica,"Microsoft Yahei",'Open Sans',Arial,"FZLanTingHei","Hiragino Sans GB","Heiti SC","WenQuanYi Micro Hei",sans-serif;;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
